import React from 'react';
import { Col } from '@cvent/carina/components/Col';
import { FlexType } from '@cvent/carina/components/Col/Col.style';
import { Row } from '@cvent/carina/components/Row';
import { ScrollViewWithBars } from '@cvent/carina/components/ScrollViewWithBars';

import { usePageStyle } from '@hooks/style/usePageStyle';
import { Copyright } from '@components/textFields/Copyright';

type PageContainerProps = {
  children: React.ReactNode;
  testID: string;
};
export const PageContainer = ({ children, testID }: PageContainerProps): JSX.Element => {
  const { background = {}, colFlex = {} } = usePageStyle();
  return (
    <Row minHeight={'100vh'} testID={`${testID}_page__row`}>
      <Col flex={colFlex as FlexType} testID={`${testID}_page__col`} css={background}>
        <ScrollViewWithBars>{children}</ScrollViewWithBars>
        <Row role={'contentinfo'} testID={`${testID}_copyright__row`}>
          <Col
            testID={`${testID}_copyright__col`}
            flex={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end' }}
          >
            <Copyright testID={testID} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
